export const APP_STORE_URL = 'https://apps.apple.com/jo/app/rink/id6769388223';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.csc.rinkdata&hl=en';

/** Universal links — better for QR codes (opens user's local store). */
export const APP_STORE_QR_URL = 'https://apps.apple.com/app/id6769388223';
export const GOOGLE_PLAY_QR_URL = 'https://play.google.com/store/apps/details?id=com.csc.rinkdata';
